<template>
  <div class="login-wrap">
    <div class="back-wrap" @click="toHome" v-if="!isMobileDevice()">返回</div>
    <div class="centerWidth detail-wrap">
      <table border="1" class="dagang">
        <tr>
          <td :colspan="3">
            <div class="title-wrap">
              <img class="img1" src="../assets/images/logo1.png" alt="">
              <img class="img2" src="../assets/images/dagang_title.png" alt="">
              <img class="img3" src="../assets/images/dagang_title1.png" alt="">
            </div>
          </td>
        </tr>
        <tr>
          <th style="width: 70%">培训内容</th>
          <th style="width: 15%">学时</th>
          <th style="width: 15%">成绩</th>
        </tr>
        <tr v-for="(item,index) in dataInfo" :key="index">
          <td>{{ item.name }}</td>
          <td v-if="index == 0" :rowspan="dataInfo.length">{{ studytime }}学时</td>
          <td v-if="index == 0" :rowspan="dataInfo.length">{{ hege }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {
  find_course,
} from "@/api/index";
import {find_chengji} from "../api";

export default {
  name: "courseList",
  data() {
    return {
      subject_id: '',
      studytime: '',
      total_score: 0,
      hege: '',
      dataInfo:[],
      isMobile: false,
      xuehao:''
    }
  },
  mounted() {
    this.xuehao = this.$route.query.xuehao
    this.getInfo()
    // if (this.$route.query.subject_id){
    //   this.subject_id = this.$route.query.subject_id
    //   this.hege = this.$route.query.hege
    //   this.getDetails()
    // }else {
    //   let info = JSON.parse(this.$route.query.info)
    //   this.subject_id = info.subject_id
    //   this.hege = info.hege
    //   this.getDetails()
    // }
  },
  methods: {
    getInfo() {
      let ajaxData = {
        xuehao: this.xuehao
      }
      find_chengji(ajaxData).then(res => {
        if (res.code == 1) {
          let dataInfo = res.data[0]

          if (Number(dataInfo.score) * 0.6 > Number(dataInfo.total_score)) {
            this.hege = '不合格'
          } else {
            this.hege = '合格'
          }
          this.getDetails(dataInfo.subject_id)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    isMobileDevice() {
      // 使用 window.innerWidth 获取视口宽度
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      // 这里我们假设宽度小于等于768px的为移动设备
      // 你可以根据实际需要调整这个阈值
      return width <= 768;
    },
    getDetails(subject_id) {
      find_course({subject_id: subject_id}).then(res => {
        if (res.code == 1) {
            this.studytime = res.data.studytime
            this.dataInfo = res.data.detail
        }
      })
    },
    toHome() {
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped lang="scss">
.login-wrap {
  //background-image: url("../assets/images/login_bj.png");
  //background-repeat: no-repeat;
  //background-size: 100% 100%;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  position: relative;
}
.back-wrap {
  cursor: pointer;
  position: absolute;
  right: 50px;
  top: 30px;
  padding: 10px 30px;
  border-radius: 20px;
  border: 1px solid #2257ab;
  color: #2257ab;
}
.detail-wrap {
  width: 900px;
  margin-top: 50px;
  margin-bottom: 50px;
  //border: 1px solid #ddd; /* 容器边框 */
  //border-radius: 10px; /* 圆角半径 */
  //overflow: hidden; /* 隐藏超出圆角的部分 */

  .tit {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 100px;
    width: 700px;
    line-height: 100px;
    margin: 0 auto;
    color: #ffffff;
    letter-spacing: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dagang {
    width: 100%;
    margin: 0 auto;
    border-radius: 15px;

    tr {
      height: 56px;

      th {
        color: #333;
        font-weight: bold;
        font-size: 18px;
      }

      td:nth-child(1) {
        padding-left: 20px;
      }

      td:nth-child(2) {
        text-align: center;
        font-size: 20px;
      }
      td:nth-child(3) {
        text-align: center;
        font-size: 20px;
      }
    }
  }
}
.title-wrap{
  width: 100%;
  box-sizing: border-box;
  padding: 20px 20px 30px 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  .img1{
    position: absolute;
    top: 20px;
    left: 20px;
  }
  .img2{
    width: 600px;
    height: 45px;
    padding-top: 30px;
  }
  .img3{
    width: 350px;
    height: 40px;
    margin-top: 30px;
  }
}
@media only screen and (max-width: 600px) {
  #app{
    width: 100%;
  }
  .detail-wrap{
    width: calc(100%);
    padding: 0 10px;
    box-sizing: border-box;
  }
  .title-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0px 10px 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;

    .img1 {
      position: absolute;
      top: 15px;
      left: 0px;
      width: 30px;
      height: 30px;
    }

    .img2 {
      width: 260px;
      height: 22px;
      padding-top: 30px;
    }

    .img3 {
      width: 160px;
      height: 18px;
      margin-top: 20px;
    }
  }
  .detail-wrap .dagang tr{
    height: auto;
  }
  .detail-wrap .dagang tr td:nth-child(1){
    padding: 10px;
  }
  .detail-wrap .dagang tr td:nth-child(2){
    white-space: nowrap;
    font-size: 18px;
  }
}
</style>
